import { HeldEmailQueueRow, HeldEmailQueueRowModel } from "./HeldEmailQueueRow";

export function HeldEmailQueueRowContainer({
  model,
}: {
  model: HeldEmailQueueRowModel;
}) {
  return <HeldEmailQueueRow model={model} />;
}
